import type { AutopayLease } from '@/components/residents/redesign/payments';
import { formatCurrency, formatShortDate } from '@/utils/common/formatting';

// `/api/v4/leases/:id` returns the lease either bare or wrapped under
// `{ response: { lease } }` / `{ response }` depending on the variation
// handler. This unwraps both shapes.
export function selectLease(queryData: unknown): any {
  const response = (queryData as any)?.response ?? queryData;
  return response?.lease ?? response;
}

export function getRecurringPayments(lease: any): any[] {
  return Array.isArray(lease?.recurringPayments) ? lease.recurringPayments : [];
}

export function hasAutoPay(lease: any): boolean {
  return getRecurringPayments(lease).length > 0;
}

export function getFirstAutoPay(lease: any): any | undefined {
  return getRecurringPayments(lease)[0];
}

export function buildAutopayLease(args: {
  leaseId: number;
  lease: any;
  primaryUser: any;
}): AutopayLease {
  const { leaseId, lease, primaryUser } = args;
  const firstAutopay = getFirstAutoPay(lease);
  const propertyName = lease?.property?.marketingName || '';
  const displayName = primaryUser?.firstName && primaryUser?.lastName
    ? `${primaryUser.firstName} ${primaryUser.lastName}`
    : 'Resident';
  const initials = (
    (primaryUser?.firstName?.[0] || '') + (primaryUser?.lastName?.[0] || '')
  ).toUpperCase() || '?';

  return {
    leaseId,
    autopayId: firstAutopay?.id,
    displayName,
    initials,
    photoUrl: primaryUser?.profilePhotoUrl,
    propertyName,
    autopayEnabled: hasAutoPay(lease),
    amount: firstAutopay?.amount
      ? formatCurrency(Number(firstAutopay.amount))
      : undefined,
    paymentMethodLabel: firstAutopay?.paymentMethodDescription || undefined,
    startDate: firstAutopay?.startDate ? formatShortDate(firstAutopay.startDate) : undefined,
    endDate: firstAutopay?.endDate ? formatShortDate(firstAutopay.endDate) : undefined,
    processedDay: firstAutopay?.processDay
      ? `${firstAutopay.processDay} of each month`
      : undefined,
  };
}
